var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 36,
    viewBox: "0 0 53 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.64014,
    y: 1.85388,
    width: 32.3788,
    height: 22.6677,
    fill: "#FFEDC8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.87245 3.47261C3.97834 3.47261 3.25351 4.19752 3.25351 5.09173C3.25351 5.09173 2.44404 7.52041 2.44404 13.1873C2.44404 18.8542 3.25351 21.2829 3.25351 21.2829C3.25351 22.1771 3.97834 22.902 4.87245 22.902C4.87245 22.902 9.72928 23.7116 17.824 23.7116C25.9187 23.7116 30.7755 22.902 30.7755 22.902C31.6697 22.902 32.3945 22.1771 32.3945 21.2829C32.3945 21.2829 33.204 18.8542 33.204 13.1873C33.204 7.52041 32.3945 5.09173 32.3945 5.09173C32.3945 4.19752 31.6697 3.47261 30.7755 3.47261C30.7755 3.47261 27.5377 2.66305 17.824 2.66305C8.11034 2.66305 4.87245 3.47261 4.87245 3.47261ZM19.4429 26.1403C20.2524 25.3307 30.7755 26.1403 30.7755 26.1403C33.4579 26.1403 35.6324 23.9656 35.6324 21.2829V5.09173C35.6324 2.40909 33.4579 0.234375 30.7755 0.234375H4.87245C2.1901 0.234375 0.015625 2.40909 0.015625 5.09173V21.2829C0.015625 23.9656 2.1901 26.1403 4.87245 26.1403C4.87245 26.1403 15.3956 25.3307 16.2051 26.1403C17.0145 26.9498 17.0145 28.569 16.2051 29.3785C15.3956 30.1881 11.3482 29.3785 11.3482 29.3785C10.4541 29.3785 9.72928 30.1034 9.72928 30.9976C9.72928 31.8918 11.3482 31.8072 13.7766 31.8072C16.2051 31.8072 21.8714 31.8072 21.8714 31.8072C22.7655 31.8072 25.9187 31.8918 25.9187 30.9976C25.9187 30.1034 25.1939 29.3785 24.2998 29.3785C24.2998 29.3785 20.2524 30.1881 19.4429 29.3785C18.6335 28.569 18.6335 26.9498 19.4429 26.1403Z",
    fill: "#DDAA42"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7302 31.6286C53.1001 27.2608 23.8269 25.3322 16.5591 26.2097C9.29137 27.0872 2.02468 33.2301 5.9001 34.1077C13.4785 35.8237 52.3604 35.9965 52.7302 31.6286Z",
    fill: "#F0EEEB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.f9dbedf540dc2837dd17b927d08934c3.svg";
export { ForwardRef as ReactComponent };